import { DataSourceClient } from '../models';

const baseExample: DataSourceClient = {
  dataSourceId: 1,
  clientId: 1
};

export const createExampleDataSourceClients = (list: Partial<DataSourceClient>[]): DataSourceClient[] =>
  list.map(data => ({ ...baseExample, ...data }));
